module.exports = __webpack_public_path__ + "img/image55.e0c32936.jpg";